import React, { PureComponent } from 'react'
import { Redirect } from 'react-router-dom'
import axios from 'axios'
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  InputGroupAddon
} from 'reactstrap'

class Login extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      errorMessage: 'Username and/or password is incorrect',
      redirect: false,
      submiting: false
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onLoginSuccess = this.onLoginSuccess.bind(this)
    this.onLoginFailure = this.onLoginFailure.bind(this)
    this.onKeyPress = this.onKeyPress.bind(this)
  }

  onInputChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSubmit() {
    const { username, password } = this.state
    this.setState({ submitting: true, error: false })
    axios
      .post(`/api/proxy/v2/auth/login`, {
        accessKey: username,
        accessPassword: password
      })
      .then(this.onLoginSuccess)
      .catch(this.onLoginFailure)
  }

  onLoginSuccess({ data }) {
    sessionStorage.setItem('token', data.access_token)
    this.getUserSelf(data.access_token)
  }

  onLoginFailure(resp) {
    this.setState({ submitting: false, error: true })
  }

  onKeyPress(e) {
    if (e.charCode === 13) {
      e.preventDefault()
      e.stopPropagation()
      this.onSubmit()
    }
  }

  getUserSelf(token) {
    axios
      .get('/api/proxy/v2/users/self', {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(({ data }) => {
        sessionStorage.setItem('user', JSON.stringify(data))
        // only allow GoNation admins to log in
        if ('goNation' in data.privyData.group) {
          if (
            data.privyData.group.goNation.some(
              groupName =>
                groupName.name === 'Admin' || groupName.name === 'SuperAdmin'
            )
          ) {
            this.setState({ submitting: false, redirect: true })
          } else {
            this.setState({
              error: true,
              errorMessage:
                'You do not have the proper privelages to access Mission Control'
            })
          }
        } else {
          this.setState({
            error: true,
            errorMessage:
              'You do not have the proper privelages to access Mission Control'
          })
        }
      })
      .catch(err => {
        console.log(err)
        return false
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <h1>Login</h1>
                    <p className="text-muted">Sign In to your account</p>
                    {this.state.error && (
                      <p style={{ color: 'red' }}>{this.state.errorMessage}</p>
                    )}
                    <InputGroup className="mb-3">
                      <InputGroupAddon>
                        <i className="icon-user" />
                      </InputGroupAddon>
                      <Input
                        type="text"
                        placeholder="Username"
                        name="username"
                        onChange={this.onInputChange}
                        value={this.state.username}
                      />
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <InputGroupAddon>
                        <i className="icon-lock" />
                      </InputGroupAddon>
                      <Input
                        type="password"
                        placeholder="Password"
                        name="password"
                        onChange={this.onInputChange}
                        onKeyPress={this.onKeyPress}
                        value={this.state.password}
                      />
                    </InputGroup>
                    <Row>
                      <Col xs="6">
                        <Button
                          onClick={this.onSubmit}
                          color="primary"
                          className="px-4"
                          disabled={
                            !this.state.username.length ||
                            !this.state.password.length
                          }
                        >
                          {this.state.submitting && (
                            <i
                              className="fa fa-circle-o-notch fa-spin"
                              style={{ marginRight: 5 }}
                            />
                          )}
                          Login
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js